export default {"src":"/_next/static/media/Frame.3b095021.svg","height":515,"width":524,"blurWidth":0,"blurHeight":0};